/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Law_Tax_Public_Admin17Inputs */

const en_cv_extract_form_enum_law_tax_public_admin17 = /** @type {(inputs: Cv_Extract_Form_Enum_Law_Tax_Public_Admin17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Law, Tax and Public Administration`)
};

const de_cv_extract_form_enum_law_tax_public_admin17 = /** @type {(inputs: Cv_Extract_Form_Enum_Law_Tax_Public_Admin17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht, Steuern und öffentliche Verwaltung`)
};

/**
* | output |
* | --- |
* | "Law, Tax and Public Administration" |
*
* @param {Cv_Extract_Form_Enum_Law_Tax_Public_Admin17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_law_tax_public_admin17 = /** @type {((inputs?: Cv_Extract_Form_Enum_Law_Tax_Public_Admin17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Law_Tax_Public_Admin17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_law_tax_public_admin17(inputs)
	return en_cv_extract_form_enum_law_tax_public_admin17(inputs)
});
export { cv_extract_form_enum_law_tax_public_admin17 as "cv_extract_form_enum_LAW_TAX_PUBLIC_ADMIN" }